import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportCashierV2Page } from './report-cashier-v2.page';

const routes: Routes = [
  {
    path: '',
    component: ReportCashierV2Page
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportCashierV2PageRoutingModule {}
